import { useIntl } from 'react-intl';
import { Button, Checkbox, Dropdown, Icon, Table } from '../../../../ui';
import { InfrastructureProps } from '../../../../interfaces/BackendModels';
import { MenuProps, message } from 'antd';
import { StyledBusinessTab } from '../style';
import React, { useMemo, useState } from 'react';
import useQueryApiClient from 'utils/useQueryApiClient';
import { CreateEditInfrastructure } from './CreateEditInfrastructure/CreateEditInfrastructure';
import { DefaultHoursProps } from 'admin/components/FarmDeliveries/types';

interface BusinessAddressesProps {
  farmId?: number;
};

export const BusinessAddresses: React.FC<BusinessAddressesProps> = ({ farmId }) => {
  const [isOpenEditCreateDrawer, setIsOpenEditCreateDrawer] =
    useState<boolean>(false);
  const [editInfrastructureId, setEditInfrastructureId] = useState<
    number | null
  >(null);
  const [reloadCount, setReloadCount] = useState<number>(0);
  const intl = useIntl();

  const stableFilter = useMemo(() => {
    return farmId ? { farmId } : undefined;
  }, [farmId]);

  const { appendData: deleteInfrastructure } = useQueryApiClient({
    request: {
      url: 'api/v2/farm/infrastructures/:id',
      method: 'DELETE',
    },
    onSuccess: () => {
      setReloadCount((prev: number) => prev + 1);
      message.success(
        intl.formatMessage({ id: 'message.sucess_infrastructure_deleted' })
      );
    },
  });

  const handleEdit = (record: InfrastructureProps) => {
    setIsOpenEditCreateDrawer(true);
    setEditInfrastructureId(record.id);
  };
  const handleDelete = (id: number) => {
    deleteInfrastructure([], { id: id });
  };
  const handleCloseDrawer = () => {
    setIsOpenEditCreateDrawer(false);
    setEditInfrastructureId(null);
  };

  const handleOpenEditCreateDrawer = () => {
    setIsOpenEditCreateDrawer(true);
  };

  const formatOpenDays = (open_hours: DefaultHoursProps[]) => {
    if (!open_hours) {
      return '';
    }
    const latvianDays = ['P.', 'O.', 'T.', 'C.', 'P.', 'S.', 'S.'];
    return open_hours
      .map((day, index) => (day.closed ? '' : latvianDays[index]))
      .filter(Boolean)
      .join(', ');
  };

  const columns = [
    {
      title: intl.formatMessage({ id: 'delivery.address' }),
      dataIndex: 'address_pak',
      render: (value: string) => value,
    },
    {
      title: intl.formatMessage({ id: 'general.name' }),
      dataIndex: 'object_name',
      render: (value: string) => value,
    },
    {
      title: intl.formatMessage({ id: 'general.working_hours' }),
      render: (record: InfrastructureProps) => {
        const text = formatOpenDays(record.open_hours);
        return <span className={'open-hours'}>{text}</span>;
      },
    },
    {
      title: intl.formatMessage({ id: 'general.statuss' }),
      render: (record: InfrastructureProps) => {
        return <Checkbox checked={record.status} disabled={true} />;
      },
      className: 'centered-column',
    },
    {
      title: intl.formatMessage({ id: 'farms.show_on_map' }),
      render: (record: InfrastructureProps) => {
        return <Checkbox checked={record.show_on_map} disabled={true} />;
      },
      className: 'centered-column',
    },
    {
      title: intl.formatMessage({ id: 'general.actions' }),
      render: (record: InfrastructureProps) => {
        const items: MenuProps['items'] = [
          {
            key: 'edit',
            label: intl.formatMessage({ id: 'general.edit' }),
            onClick: () => handleEdit(record),
          },
          {
            key: 'delete',
            label: intl.formatMessage({ id: 'general.delete' }),
            onClick: () => {
              handleDelete(record.id);
            },
            disabled: !record.editable,
          },
        ];

        return (
          <Dropdown menu={{ items }} trigger={['click']} key={record.id}>
            <Button
              label={intl.formatMessage({ id: 'general.actions' })}
              icon={<Icon name={'arrow-down-black'} type={'any'} />}
              iconPosition={'end'}
            />
          </Dropdown>
        );
      },
    },
  ];

  return (
    <StyledBusinessTab>
      <Button
        label={intl.formatMessage({ id: 'general.add_address' })}
        type={'primary'}
        className={'new-btn'}
        onClick={handleOpenEditCreateDrawer}
      />
      <Table
        url={'/api/v2/farm/infrastructures'}
        columns={columns}
        reload={reloadCount}
        filter={stableFilter}
      />
      <CreateEditInfrastructure
        open={isOpenEditCreateDrawer}
        editInfrastructureId={editInfrastructureId}
        setReloadCount={setReloadCount}
        onClose={handleCloseDrawer}
      />
    </StyledBusinessTab>
  );
};
